export const getFormulaImageUrl = (src: string) => {
  return `https://static.viome.com/media/app/products/${src}`;
};
